import { render, staticRenderFns } from "./roomConfirm.vue?vue&type=template&id=19d153d4&scoped=true&"
import script from "./roomConfirm.vue?vue&type=script&lang=js&"
export * from "./roomConfirm.vue?vue&type=script&lang=js&"
import style0 from "./roomConfirm.vue?vue&type=style&index=0&id=19d153d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d153d4",
  null
  
)

export default component.exports